<div fxLayout="column" ngClass="p-b-xxl" fxFlex="100%">
	<div fxLayout="row" fxLayoutAlign="center">
		<div
			fxLayout.gt-xs="row"
			fxLayout.xs="column"
			fxLayoutAlign.lt-sm="space-between"
			fxLayoutGap="8%"
			fxFlex.gt-md="88%"
			fxFlex.md="100%"
			ngClass.gt-xs="grey-bg p-xl"
			ngClass.lt-sm="grey-bg p-l-l p-r-l p-t-l"
		>
			<div fxLayout="column" fxFlex="35%">
				<mat-card
					class="mat-elevation-z0 hover-on-svg"
				>
				<mat-card-content class="homepage-org-bg" style="border-radius: 15px">
					<div
						fxLayout="column"
						ngClass.md="p-t-l"
						ngClass.gt-md="p-t-l p-b-s"
						fxFlex="100%"
					>
						<div
							fxLayout="column"
							fxLayoutGap="12%"
							fxLayoutAlign="center center"
						>
							<div
								fxLayout="row"
								fxFlex="70%"
								fxLayoutAlign="center"
								ngClass.sm="p-t-s p-l-xl p-r-xl"
								ngClass.xs="p-t-m"
							>
								<img
									fxFill
									src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/zeroPercent/public"
								/>
							</div>
							<div fxLayout="row" fxFlex="100%" fxLayoutAlign="center">
								<p
									class="mat-headline-6 dark-grey-texts text-align-center"
									i18n="@@homepage_organisation_startFund_wdPlatformFee"
								>
									WHYDONATE PLATFORM FEE
								</p>
							</div>
						</div>
					</div>
				</mat-card-content>
				</mat-card>
			</div>
			<div
				fxLayout="column"
				fxLayoutAlign="center flex-start"
				ngClass.xs="p-t-m"
				fxLayoutGap="2%"
				fxFlex="55%"
				class="dark-grey-texts"
			>
				<div fxLayout="column">
					<h2 i18n="@@homepage_organisation_startFund_startYourFund">
						Start Your Fundraiser
					</h2>
				</div>
				<div fxLayout="column">
					<span
						class="mat-headline-6"
						i18n="@@homepage_organisation_startFund_startYourFundContent"
						>WhyDonate makes online fundraising easy and accessible for
						charities and individuals all over the world. 0% platform fee, so
						let's start.</span
					>
				</div>
				<div fxLayout="column">
					<app-start-fundraiser-button
						buttonType="homepage6"
					></app-start-fundraiser-button>
				</div>
			</div>
		</div>
	</div>
</div>
